module.exports = __webpack_public_path__ + "static/img/paytype1_demo.9764c5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paytype1_demo.jpg
// module id = 9rfw
// module chunks = 171